import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useUpdatePlanMenuCloseDimensionMutation } from 'core/api/PlanMenuCloseDimensionApi'
import {
  AppNotification,
  NotificationType,
} from 'components/notification/Notification'
import { SelectPopup } from 'components/SelectPopup'
import { UniversalSelectItem } from '../FrozeMillet/FrozeMillet'

import { useGetBuffetDishQuery } from 'core/api/BuffetDishApi'
import {
  IBuffetDishDto,
  IBuffetDishesRequest,
} from 'core/api/dto/BuffetDishDto'
import { ConfirmReplacePopup } from './ConfirmReplacePopup'
import { useGetPlanMenuControlDimensionDetailQuery } from 'core/api/PlanMenuControlApi'
import { IPlanMenuCloseOrderDetailDto } from 'core/api/dto/PlanMenuCloseDto'

interface IPopupProps {
  setIsShowPopup: (arg: boolean) => void
  dimensionId?: string | null
  dishId?: string | null
  orderDetail?: IPlanMenuCloseOrderDetailDto
}

const AddDishPopup = ({
  setIsShowPopup,
  dimensionId,
  dishId,
  orderDetail,
}: IPopupProps) => {
  const { t } = useTranslation()
  const [showConfirmPopup, setShowConfirmPopup] = useState(false)
  const [updatePlanMenuCloseDimension] =
    useUpdatePlanMenuCloseDimensionMutation()

  const [inputValue, setInputValue] = useState<string>('')
  const [currentDish, setCurrentDish] = useState<IBuffetDishDto | null>(null)
  const [dishList, setDishList] = useState<IBuffetDishDto[]>([])

  const [params, setParams] = useState<IBuffetDishesRequest>({
    limit: 10,
    offset: 0,
    search: '',
    is_archived: false,
  })

  // Фильтрация/поиск
  useEffect(() => {
    const handler = setTimeout(() => {
      setParams({
        limit: 10,
        offset: 0,
        search: inputValue,
        is_archived: false,
      })
    }, 500)
    return () => clearTimeout(handler)
  }, [inputValue])

  const { data: dataDish } = useGetBuffetDishQuery({
    ...params,
    is_archived: false,
  })

  // Обновление списка при подгрузке
  useEffect(() => {
    if (!dataDish) return

    if (params.offset === 0) {
      setDishList(dataDish.results)
    } else {
      setDishList((prev) => [...prev, ...dataDish.results])
    }
  }, [dataDish])

  // Подгрузка следующей страницы
  const nextPageHandler = () => {
    setParams((prev) => ({
      ...prev,
      offset: (prev.offset || 0) + 10,
    }))
  }
  const confirmSelect = () => {
    setShowConfirmPopup(true)
  }
  // Сохранение выбранной тары
  const saveDish = (selectedItem: IBuffetDishDto) => {
    if (!selectedItem) return

    if (dimensionId) {
      updatePlanMenuCloseDimension({
        id: Number(dimensionId),
        data: { dish: selectedItem.id },
      })
        .unwrap()
        .then(() => {
          AppNotification({
            msg: t('Блюдо добавлено'),
            type: NotificationType.success,
          })
          setIsShowPopup(false)
        })
    }
  }
  const currentOrder = orderDetail?.orderLines.find(
    (item) => Number(dishId || 0) === item.id,
  )

  const { data: currentDimension } = useGetPlanMenuControlDimensionDetailQuery(
    { id: Number(dimensionId) },
    { skip: !dimensionId },
  )
  return (
    <>
      <SelectPopup
        title={t('Замена блюда в замере')}
        items={dishList}
        selectedId={currentDish?.id}
        renderItem={(item, selected, onClick) => (
          <UniversalSelectItem
            data={item}
            onClick={() => {
              setCurrentDish(item)
              onClick()
            }}
            isSelected={selected}
            getTitle={(data) => data.name}
            getSubtitle={() => t('Наименование блюда')}
            getImage={(data) => data.imagePreviewOnS3 || data.image || null}
          />
        )}
        onSave={(item) => {
          confirmSelect()
          // setIsShowPopup(false)
        }}
        onClose={() => setIsShowPopup(false)}
        hasMore={!!dataDish?.next}
        onLoadMore={nextPageHandler}
        searchable={true}
        inputValue={inputValue}
        onInputChange={setInputValue}
      />
      {showConfirmPopup && currentDish && currentDimension && (
        <ConfirmReplacePopup
          currentDimension={currentDimension}
          oldItem={currentOrder?.dish}
          newItem={currentDish}
          onConfirm={() => {
            saveDish(currentDish)
            setShowConfirmPopup(false)
            setIsShowPopup(false)
          }}
          onCancel={() => setShowConfirmPopup(false)}
        />
      )}
    </>
  )
}

export default AddDishPopup
